/**
 * Утиліта для роботи з Telegram HapticFeedback API
 * Дозволяє додавати тактильний зворотний зв'язок при взаємодії з інтерфейсом
 */

type ImpactStyle = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';
type NotificationType = 'error' | 'success' | 'warning';

/** Telegram Mini App WebApp surface from @types/telegram-web-app. */
type TelegramWebApp = Window['Telegram']['WebApp'];

/**
 * Отримує Telegram WebApp API (undefined outside Telegram / when SDK missing).
 */
function getTelegramWebApp(): TelegramWebApp | undefined {
  try {
    return window.Telegram?.WebApp;
  } catch {
    return undefined;
  }
}

/**
 * Викликає impact вібрацію (для кнопок, кліків)
 * @param style - стиль вібрації (за замовчуванням 'light')
 */
export function impactOccurred(style: ImpactStyle = 'light'): void {
  const tg = getTelegramWebApp();
  if (tg?.HapticFeedback?.impactOccurred) {
    try {
      tg.HapticFeedback.impactOccurred(style);
    } catch (error) {
      // Ігноруємо помилки, якщо API недоступний
      console.debug('[HapticFeedback] impactOccurred failed:', error);
    }
  }
}

/**
 * Викликає notification вібрацію (для сповіщень про результат дії)
 * @param type - тип сповіщення
 */
export function notificationOccurred(type: NotificationType): void {
  const tg = getTelegramWebApp();
  if (tg?.HapticFeedback?.notificationOccurred) {
    try {
      tg.HapticFeedback.notificationOccurred(type);
    } catch (error) {
      console.debug('[HapticFeedback] notificationOccurred failed:', error);
    }
  }
}

/**
 * Викликає selection change вібрацію (при зміні вибору)
 */
export function selectionChanged(): void {
  const tg = getTelegramWebApp();
  if (tg?.HapticFeedback?.selectionChanged) {
    try {
      tg.HapticFeedback.selectionChanged();
    } catch (error) {
      console.debug('[HapticFeedback] selectionChanged failed:', error);
    }
  }
}

